var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrevious = function SvgPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M13.493 4.814v6.38c0 1.306-1.42 2.126-2.553 1.473l-2.767-1.594-2.766-1.6a1.696 1.696 0 0 1 0-2.94l2.766-1.6L10.94 3.34c1.133-.653 2.553.16 2.553 1.474M2.507 12.62a.504.504 0 0 1-.5-.5V3.88c0-.273.226-.5.5-.5.273 0 .5.227.5.5v8.24c0 .273-.227.5-.5.5"
  })));
};
export default SvgPrevious;